import { useLocation, useNavigate, useSearchParams } from 'react-router-dom'

interface IAgentNavigationState {
  agentSchedulesOverlay?: boolean
}

// Keep existing schedule links working; they now open a dialog over the conversation.
export function useAgentNavigation() {
  const [params, setParams] = useSearchParams()
  const location = useLocation()
  const navigate = useNavigate()
  const schedulesOpen = params.get('view') === 'schedules'
  const selectedId = schedulesOpen ? params.get('schedule') : null
  const openSchedules = (id?: string) => {
    const next = new URLSearchParams(params)
    next.set('view', 'schedules')
    if (id) next.set('schedule', id)
    else next.delete('schedule')
    setParams(next, {
      replace: schedulesOpen,
      state: schedulesOpen ? location.state : { agentSchedulesOverlay: true },
    })
  }
  const closeSchedules = () => {
    // Return to the chat entry that opened this overlay; direct links have no such entry.
    if (schedulesOpen && (location.state as IAgentNavigationState | null)?.agentSchedulesOverlay) {
      navigate(-1)
      return
    }
    const next = new URLSearchParams(params)
    next.delete('view')
    next.delete('schedule')
    setParams(next, { replace: true, state: location.state })
  }
  return { schedulesOpen, selectedId, openSchedules, closeSchedules }
}
